import { render, staticRenderFns } from "./ButtonListMapKanban.vue?vue&type=template&id=4dd8828b"
import script from "./ButtonListMapKanban.vue?vue&type=script&lang=js"
export * from "./ButtonListMapKanban.vue?vue&type=script&lang=js"
import style0 from "./ButtonListMapKanban.vue?vue&type=style&index=0&id=4dd8828b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports